import styled from 'styled-components';
import { COLORS, FONTS } from '../../ui';

interface Props {
  hide?: boolean;
}

const Row = styled.div`
  width: 100%;
  padding: 16px 0;
`;

const Cell = styled.div`
  display: ${(props: Props) => props.hide ? 'none' : 'flex'};
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const Head = styled.div`
  background-color: ${COLORS.BORDER_GRAY};
  display: none;
  padding: 0 16px;

  ${Row} {
    padding: 16px;
  }

  ${Cell} {
    font-weight: bold;
  }
`;

const Body = styled.div`
  font-size: 14px;

  ${Row} {
    background-color: ${COLORS.CONTENT_GRAY};
    margin-top: 16px;
    padding: 16px;
  }

  ${Cell} {
    margin: 4px 0;
    word-break: break-word;
  }
`;

const Title = styled.div`
  font-weight: bold;
  margin-right: 10px;
`;

const Table = styled.div`
  width: 100%;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.BLACK};

  @media(min-width: 1280px) {
    ${Head} {
      display: flex;
    }

    ${Body} {
      padding: 0 16px;
      background-color: ${COLORS.CONTENT_GRAY};
      font-size: 14px;
      margin: 0;
    }

    ${Row} {
      margin: 0;
      display: flex;
      border-bottom: 1px solid ${COLORS.DARK_GRAY};
    }

    ${Cell} {
      display: flex;
      flex: 1;
      justify-content: center;
    }

    ${Title} {
      display: none;
    }
  }
`;

Table.Cell = Cell;
Table.Row = Row;
Table.Head = Head;
Table.Body = Body;
Table.Title = Title;

export { Table }
